import { ZodError } from "zod";
import { issueToString } from "../zodWrapper.js";
export class MessageSpec {
    parser;
    name = "";
    constructor(parser) {
        this.parser = parser;
    }
}
export class VoidMessageSpec extends MessageSpec {
    constructor() {
        super({ parse: (_) => { } });
    }
}
export class MessageProcessor {
    #listenersByMessageTypeName = new Map();
    addCallback(spec, fn) {
        this.#listenersByMessageTypeName.set(spec.name, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: fix this
            callback: (data, context) => fn(data, context),
            parser: (data) => spec.parser.parse(data),
        });
        return this;
    }
    async parse(message, context) {
        const processor = this.#listenersByMessageTypeName.get(message.typeName);
        if (processor == undefined) {
            throw new Error(`Unrecognized message type name: ${message.typeName}`);
        }
        let parsed;
        try {
            parsed = processor.parser(message.data);
        }
        catch (err) {
            if (err instanceof ZodError) {
                let errorMessage = `The type validator found an error with the data.`;
                for (const issue of err.issues) {
                    errorMessage += `\n${issueToString(issue)}`;
                }
                throw new Error(errorMessage, { cause: err });
            }
            throw err;
        }
        await processor.callback(parsed, context);
    }
    serialize(spec, data) {
        return {
            typeName: spec.name,
            data: data,
        };
    }
}
//# sourceMappingURL=MessageProcessor.js.map